export const ROLE_TYPES = {
  FUNCTIONAL: 'Functional',
  TECHNICAL: 'Technical',
  ORGANIZATIONAL: 'Organizational'
};

// used for the roles selection in the employee form
export const ROLE_TYPE_COLORS = {
  [ROLE_TYPES.FUNCTIONAL]: {
    background: '#FFF3E0',
    text: '#FF9800',
    backgroundSelected: '#FF9800',
    backgroundSelectedLight: '#FFF3E0',
    border: '#FF9800'
  },
  [ROLE_TYPES.TECHNICAL]: {
    background: '#FFF3E0',
    text: '#FF9800',
    backgroundSelected: '#FF9800',
    backgroundSelectedLight: '#FFF3E0',
    border: '#FF9800'
  },
  [ROLE_TYPES.ORGANIZATIONAL]: {
    background: '#FFF3E0',
    text: '#FF9800',
    backgroundSelected: '#FF9800',
    backgroundSelectedLight: '#FFF3E0',
    border: '#FF9800'
  },
  position: {
    background: '#E3F2FD',
    text: '#2196F3',
    backgroundSelected: '#2196F3',
    backgroundSelectedLight: '#B3E5FC',
    border: '#2196F3'
  },
  grade: {
    background: '#dcfce7',
    text: '#16a34a',
    backgroundSelected: '#16a34a',
    backgroundSelectedLight: '#B3E5FC',
    border: '#4ade80'
  }
};

/*
const ROLE_TYPE_COLORS = {
  [ROLE_TYPES.FUNCTIONAL]: {
    background: '#e3f2fd',
    text: '#1976d2',
    backgroundSelected: '#1976d2',
  },
  [ROLE_TYPES.ORGANIZATIONAL]: {
    background: '#f3e5f5',
    text: '#9c27b0',
    backgroundSelected: '#9c27b0',
  },
  [ROLE_TYPES.TECHNICAL]: {
    background: '#e8f5e9',
    text: '#2e7d32',
    backgroundSelected: '#2e7d32',
  }
};
*/

export const getRoleChipStyle = (roleType) => {
  let bgColor = '#F8FAFC';
  let textColor = '#64748B';
  
  // Set colors based on role type using ROLE_TYPES constant
  switch (roleType) {
    case ROLE_TYPES.FUNCTIONAL:
      bgColor = '#E6F4EA';
      textColor = '#1E8E3E';
      break;
    case ROLE_TYPES.TECHNICAL:
      bgColor = '#E8F0FE';
      textColor = '#1967D2';
      break;
    case ROLE_TYPES.ORGANIZATIONAL:
      bgColor = '#FEF3C7';
      textColor = '#D97706';
      break;
    default:
      break;
  }
  
  return { bgColor, textColor };
};